import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-store-desk",
  "use": "icon-soc-l1-store-desk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-store-desk\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M160 256h704v96H160V256zm64 128h576v384H224V384zm96 64v64h384v-64H320zm0 128v64h256v-64H320z\" />\r\n  <path d=\"M320 832h384v48H320v-48z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-store-desk.svg
// module id = 31wY
// module chunks = 546